import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 *
 * Search for link categories.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.LINK_CATEGORIES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const LinkCategoryService = {
  FindMany
}

export default LinkCategoryService
